import { render, staticRenderFns } from "./FormUser.vue?vue&type=template&id=810d9718&"
import script from "./FormUser.vue?vue&type=script&lang=js&"
export * from "./FormUser.vue?vue&type=script&lang=js&"
import style0 from "./FormUser.vue?vue&type=style&index=0&id=810d9718&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports